<template>
  <div class="background-task-item">
    <div class="task-details">
      <div class="flex-center justify-between">
        <div class="task-name">
          {{ taskName }}
        </div>
        <div v-if="isTaskCompleted" id="task-status-completed" class="task-status-completed">
          <span>{{ 'general_completed' | translate }}</span>
        </div>
      </div>
      <div id="task-datetime-started" class="task-datetime">
        {{ 'general_started' | translate }}: {{ taskDateTime.started }}
      </div>
      <div v-if="taskDateTime.ended" id="task-datetime-ended" class="task-datetime">
        {{ 'general_finished' | translate }}: {{ taskDateTime.ended }}
      </div>
      <div v-if="!isTaskCompleted" id="emails-in-progress" class="emails-in-progress">
        {{ messages.emails_in_progress }}
      </div>
      <div v-else id="completed-tasks-container">
        <div class="completed-tasks">
          {{ messages.successful_emails_sent }}
        </div>
        <div v-if="failedTasksCount" id="failed-tasks" class="failed-tasks">
          {{ messages.failed_emails_sent }}
        </div>
      </div>
      <div class="progress">
        <div
          id="progress-bar"
          class="progress-bar"
          :style="{ width: `${completedProgress}%` }" />
        <div
          id="failed-progress-bar"
          class="failed-progress-bar"
          :style="{ width: `${failedProgress}%` }" />
      </div>
    </div>
  </div>
</template>

<script>
import { BACKGROUND_TASK } from '@/utility/constants';

export default {
  name: 'BackgroundTaskItem',
  props: {
    task: {
      type: Object,
      required: true,
    },
  },
  data() {
    const { translate } = this.$options.filters;
    return {
      translate,
    };
  },
  computed: {
    messages() {
      return {
        sendEmailToInterested: this.translate('send_email_to_interested'),
        sendEmailToApplicants: this.translate('send_email_to_applicants'),
        failed_emails_sent: this.translate('failed_emails_sent').replace('[d]', this.failedTasksCount),
        successful_emails_sent: this.translate('successful_emails_sent')
          .replace('[d]', this.completedTasks),
        emails_in_progress: this.translate('emails_in_progress')
          .replace('[d]', this.inProgressTasks).replace('[dd]', this.task.total_tasks),
      };
    },
    taskDateTime() {
      const format = 'DD.MM.YYYY HH:mm:ss';
      return {
        started: this.task.created ? moment(this.task.created, format).format(format) : '',
        ended: this.task.finish_time ? moment(this.task.finish_time, format).format(format) : '',
      };
    },
    taskName() {
      return this.task.action === BACKGROUND_TASK.ACTION.SEND_APPLICATION
        ? this.messages.sendEmailToApplicants
        : this.messages.sendEmailToInterested;
    },
    isTaskCompleted() {
      return BACKGROUND_TASK.PROGRESS_STATE.COMPLETED_STATES.includes(this.task.state);
    },
    completedTasks() {
      return this.task.completed_tasks;
    },
    failedTasksCount() {
      return this.task.failed_tasks + this.task.terminated_tasks;
    },
    inProgressTasks() {
      return this.task.completed_tasks + this.failedTasksCount;
    },
    completedProgress() {
      if (!this.task.total_tasks) return 0;
      return (this.task.completed_tasks / this.task.total_tasks) * 100;
    },
    failedProgress() {
      if (!this.task.total_tasks) return 0;
      return ((this.task.failed_tasks + this.task.terminated_tasks) / this.task.total_tasks) * 100;
    },
  },
};
</script>

<style scoped lang="scss">
  .background-task-item {
    padding: 20px;
    background: $color-back-light;
    border-radius: 8px;

    .task-datetime,
    .completed-tasks,
    .emails-in-progress,
    .failed-tasks {
      font-size: 14px;
      color: $color-text-secondary;
    }

    .task-status-completed {
      height: 24px;
      padding: 3px 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 700;
      background: $color-success-light;
      color: $color-success;
      text-transform: uppercase;
    }

    .task-details {
      display: flex;
      flex-direction: column;

      .task-name {
        font-size: 14px;
        color: $color-text-primary;
        font-weight: $font-weight-bold;
      }

      .progress {
        width: 100%;
        height: 8px;
        background-color: #D8E0E4;
        border-radius: 4px;
        margin-top: 16px;
        overflow: hidden;
        display: flex;

        .progress-bar {
          width: 100%;
          height: 100%;
          background-color: $color-theme;
          transition: width 0.5s ease-in-out;
        }
        .failed-progress-bar {
          background-color: $color-danger;
          transition: width 0.5s ease-in-out;
        }
      }
    }
  }
</style>
